import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';

const SelectFieldWrapper = ({ field, value, onChange, error }) => {
  return (
    <FormControl fullWidth margin="normal" error={!!error}>
      <InputLabel>{field.label}</InputLabel>
      <Select
        name={field.name}
        value={value}
        label={field.label}
      onChange={(e) => onChange(field.name, e.target.value)}
      //       onChange={(e) => {
      //   // ažurira vrednost u formi
      //   onChange(field.name, e.target.value);

      //   // poziva custom onChange iz definicije polja (ako postoji)
      //   if (field.onChange) {
      //     field.onChange(e.target.value);
      //   }
      // }}
      >
        {field.options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SelectFieldWrapper;
